import { render, staticRenderFns } from "./SelectDocumentTypeDialog.vue?vue&type=template&id=6d7f58a1&lang=pug&"
import script from "./SelectDocumentTypeDialog.vue?vue&type=script&lang=js&"
export * from "./SelectDocumentTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports